/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */

import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { DcrSwitch } from '@diekeure/dcr-components';
import { BaseProxyComponent } from '../lib/base.proxy';
import { ProxyWebComponent } from './../lib/utils';

export declare interface DcrSwitchComponent extends DcrSwitch {
  checkedChange: EventEmitter<CustomEvent<boolean>>;
}

@ProxyWebComponent()
@Component({
  selector: `
    dcr-switch[formControl],
    dcr-switch[formControlName],
    dcr-switch[ngModel]
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: [
    'checked',
    'disabled',
    'label',
    'supportingText',
    'required',
    'selectedIcon',
    'unselectedIcon',
    'invalid',
    'validationMessage',
  ],
})
export class DcrSwitchComponent extends BaseProxyComponent {
  @Output() checkedChange: EventEmitter<CustomEvent<boolean>> = new EventEmitter<CustomEvent<boolean>>();
}
